import FormXuLyHoacGiaiQuyet from './FormXuLyHoacGiaiQuyet.jsx';

export {
  FormXuLyHoacGiaiQuyet
}


// WEBPACK FOOTER //
// ./src/components/modules/handle-letters/xu-ly-don/index.js